module.exports = __webpack_public_path__ + "static/media/product2@2x.8aea11d4.png";